import { createContext } from 'react';
import { ConversationUnreadMessagesData } from './hooks';
import { ChatConversationRef, ChatUiMessage, ChatUpdatedRef } from 'types/chat';

export interface IChatContext {
  conversation: ChatConversationRef | null;
  roomConversation: ChatConversationRef | null;
  identity: string;
  isConnected: boolean;
  allConversations: ChatConversationRef[];
  conversationsUnreadMessagesData: Map<string, ConversationUnreadMessagesData>;
  lastUpdatedChat: ChatUpdatedRef | null;
  isChatOpen: boolean;
  openChat(staffId: string, patientId: string, targetDisplayName?: string): void;
  openChatByUniqueName(uniqueName: string): void;
  openRoomChat(roomName: string): void;
  addPatientToRoomChat(patientId: string, roomName: string): void;
  closeChat(): void;
  closeRoomChat(): void;
  sendMessage: (text: string) => Promise<number>;
  sendMessageToRoomChat: (message: string | FormData) => Promise<number>;
  getMessages(isGroup: boolean): ChatUiMessage[];
  getParticipants(isGroup: boolean): Map<string, string>;
  getTypingParticipants(isGroup: boolean): string[];
}

export const ChatContext = createContext<IChatContext | null>(null);
export const ChatConsumer = ChatContext.Consumer;
